export const COMBINED_BANDS = [
  { label: 'T5', start: 1, end: 5 },
  { label: 'T10', start: 6, end: 10 },
  { label: 'T15', start: 11, end: 15 },
  { label: 'T20', start: 16, end: 20 },
];

// Display adapter only: preserve the API's ranked slots, including tied scores.
// Never sort, fill from a different signal, or move a later number into a gap.
export const combinedPredictionBands = (predictions) => {
  const available = Array.isArray(predictions);
  const seen = new Set();
  const entries = available ? predictions.map((entry, index) => {
    const value = entry?.number;
    const valid = Number.isInteger(value) && value >= 1 && value <= 50 && !seen.has(value);
    if (valid) seen.add(value);
    return { rank: index + 1, number: valid ? value : null, state: valid ? 'issued' : 'unavailable' };
  }) : [];
  const bands = COMBINED_BANDS.map(band => ({
    ...band,
    entries: Array.from({ length: 5 }, (_, index) => {
      const rank = band.start + index;
      return entries[rank - 1] || { rank, number: null, state: available ? 'not-issued' : 'unavailable' };
    }),
  }));
  return { available, bands, additional: entries.slice(20), issuedCount: seen.size };
};
